import { Map } from 'immutable';
import { actionTypes as MatSettingsPageActionsType } from '../../../actions/Administration/MatSettingsPage/matSettingsPageActions';
import { default as createAssetTypeWizardReducer } from './createAssetTypeWizardReducer';
import { default as createMaterialTypeFormReducer } from './createMaterialTypeFormReducer';
import { default as createKitTypeFormReducer } from './createKitTypeFormReducer';
import { default as digitalTwinViewReducer } from './digitalTwinViewReducer';
import { default as shiftSettingsDialogReducer } from './shiftSettingsDialogReducer';
import { default as shiftTypesSettingsReducer } from './shiftTypesSettingsReducer';
import { default as shiftsSchedulerReducer } from './shiftsSchedulerReducer';
import { default as weeklyShiftsViewReducer } from './weeklyShiftsViewReducer';
// import { default as updateKitTypeVersionReducer } from '../../Dialogs/UpdateKitTypeVersionDialog/updateKitTypeVersionDialogReducer';
import { default as updateMaterialQplVersionReducer } from './updateMaterialQplVersionDialogReducer';
import { default as qplFormReducer } from './qplFormReducer';
import { default as qplTestFormReducer } from './qplTestFormReducer';
import {MatSettingsMenuItemsIds} from '../../../enums/navigationMenuItemsIds';
import PermissionManager from 'infrastructure/js/utils/permissionManager';


let defaultState = {
  selectedMenuItemId : (__DEV__ && PermissionManager.hasAssetTypesTabPermissions()) ?
    MatSettingsMenuItemsIds.NAV_ELEMENT_ASSET_TYPES : MatSettingsMenuItemsIds.NAV_ELEMENT_PROJECTS
};

export default function(state = Map(defaultState), action) {
  state = state.set('createAssetTypeWizard', createAssetTypeWizardReducer(state.get('createAssetTypeWizard'), action));
  state = state.set('createMaterialTypeForm', createMaterialTypeFormReducer(state.get('createMaterialTypeForm'), action));
  state = state.set('createKitTypeForm', createKitTypeFormReducer(state.get('createKitTypeForm'), action));
  state = state.set('digitalTwinView', digitalTwinViewReducer(state.get('digitalTwinView'), action));
  state = state.set('shiftTypesSettings', shiftTypesSettingsReducer(state.get('shiftTypesSettings'), action));
  state = state.set('shiftsScheduler', shiftsSchedulerReducer(state.get('shiftsScheduler'), action));
  state = state.set('shiftSettingsDialog', shiftSettingsDialogReducer(state.get('shiftSettingsDialog'), action));
  state = state.set('weeklyShifts', weeklyShiftsViewReducer(state.get('weeklyShifts'), action));
  // state = state.set('updateKitTypeVersionDialog', updateKitTypeVersionReducer(state.get('updateKitTypeVersionDialog'), action));
  state = state.set('updateMaterialQplVersionDialog', updateMaterialQplVersionReducer(state.get('updateMaterialQplVersionDialog'), action));
  state = state.set('qplForm', qplFormReducer(state.get('qplForm'), action));
  state = state.set('qplTestForm', qplTestFormReducer(state.get('qplTestForm'), action));
  switch (action.type) {

    case MatSettingsPageActionsType.ADMINISTRATION_MAT_SETTINGS_SELECTED_MENU_ITEM_CHANGED:
      return state.set('selectedMenuItemId', action.payload);

    default:
      return state;
  }
}



